document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.gallery').forEach(gal => {

    const container = gal.querySelector('.gallery__items');

    if (! container) return;

    const items = Array.from(gal.querySelectorAll('.gallery__slide'));
    const navItems = gal.querySelector('.gallery__buttons') ? Array.from(gal.querySelector('.gallery__buttons').children) : false;
    const mobNavItems = gal.querySelectorAll('.gallery__slide-toggle') ? Array.from(gal.querySelectorAll('.gallery__slide-toggle')) : false;
    const imageItems = gal.querySelector('.gallery__summary-image') ? Array.from(gal.querySelector('.gallery__summary-image').children) : false;

    items[0].dataset.start = '';
    setTimeout(() => delete items[0].dataset.start);

    function go(index) {
      for (let i = 0; i < items.length; i++) {
        items[i].hidden = index !== i;
        if (navItems) {
          setTimeout(() => {
            navItems[i].setAttribute('aria-selected', String(index === i));
          }, 50);
        }
      }
    }

    function mobGo(index) {
      for (let i = 0; i < items.length; i++) {
        items[i].hidden = index !== i;
        imageItems[i].setAttribute('aria-hidden', String(index !== i));
        imageItems[i].hidden = Boolean(index !== i);
        if (mobNavItems) {
          // setTimeout(() => {
            mobNavItems[i].setAttribute('aria-selected', String(index === i));
          // }, 50);
        }
      }
    }

    function prev() {
      const prevIndex = items.findIndex(el => ! el.hidden) - 1;
      go(prevIndex < 0 ? items.length - 1 : prevIndex);
    }

    function next() {
      const nextIndex = items.findIndex(el => ! el.hidden) + 1;
      go(nextIndex >= items.length ? 0 : nextIndex);
    }

    if (navItems) {
      navItems.forEach(el => {
        el.addEventListener('focus', (e) => {
          go(navItems.indexOf(el));
          el.dataset.clicked = '';
          e.preventDefault();
        });
        el.addEventListener('mouseover', (e) => {
          go(navItems.indexOf(el));
          el.dataset.clicked = '';
          e.preventDefault();
        });
        el.addEventListener('animationend', next);
      });
    }

    if (mobNavItems) {
      mobNavItems.forEach(el => {
        el.addEventListener('click', (e) => {
          mobGo(mobNavItems.indexOf(el));
          el.dataset.clicked = '';
          e.preventDefault();
        });
        el.addEventListener('animationend', next);
      });
    }

    if (gal.querySelector('.gallery__nav-next')) {
      gal.querySelector('.gallery__nav-next').addEventListener('click', (e) => {
        next();
      });
    }

    if (gal.querySelector('.gallery__nav-prev')) {
      gal.querySelector('.gallery__nav-prev').addEventListener('click', (e) => {
        prev();
      });
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowRight') {
        next();
        event.preventDefault();
      } else if (event.key === 'ArrowLeft') {
        prev();
        event.preventDefault();
      }
    });

    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    function handleGesture(touchstartX, touchstartY, touchendX, touchendY) {
        const delx = touchendX - touchstartX;
        const dely = touchendY - touchstartY;
        if(Math.abs(delx) > Math.abs(dely)){
            if(delx > 0) return "right"
            else return "left"
        }
        else if(Math.abs(delx) < Math.abs(dely)){
            if(dely > 0) return "down"
            else return "up"
        }
        else return "tap"
    }

    gal.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }, false);

    gal.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        let direction = handleGesture(touchstartX, touchstartY, touchendX, touchendY);
        if (direction == 'right') {
          next();
        } else if (direction == 'left') {
          prev();
        }
    }, false);


  });
});
